import {Component} from '@angular/core';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-vat',
  templateUrl: './vat.component.html',
  styleUrls: ['./vat.component.scss'],
})
export class VatComponent {}
